// filepath: apps/web/src/features/cabinet/chrome/useProcessCount.ts
//
// FR-UI-CABINET-2 AC-14 — sidebar badge count for failed instances.
//
// Reuses the existing `useFailedInstances` hook (FR-UI-PROC-1) and
// returns just the count. The TanStack Query cache is shared with
// the failed-instance dashboard, so mounting this hook on the
// sidebar does NOT trigger a duplicate fetch — both surfaces read
// the same cache entry keyed by [procKeys.failedInstances, slug].
//
// AC-14: hidden when count is 0 (callers should treat 0 as "no
// badge"). The hook returns the raw number so the caller decides
// visibility.

import { useFailedInstances } from "@/features/proc/useFailedInstances";

export function useProcessCount(): number {
  const { data } = useFailedInstances();
  return data?.instances.length ?? 0;
}
